<template>
  <!-- 禁止横屏 -->
  <div class="appSize">
    <div class="appSize_box">
      <div class="appSize_img"></div>
    </div>
    <div class="appSize_txt">{{$t('resize')}}</div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>